import { routes } from "@/utils/constants";

export const NAVBAR_ITEMS = [
  { label: "EMPLOYEES", path: routes.admin },
  { label: "PRODUCTS", path: routes.adminProducts },
];
